export default [
    {
        path: "/",
        icon: "dashboard",
        title: "dashboard",
        can: "view_dashboard"
    },
    {
        path: "/roznamcha",
        icon: "sync_alt",
        title: "daily_transactions",
        cans: [
            "all_credits",
            "all_debits",
            "all_exchanges",
            "all_a2a_transfers",
            "all_send_transfers",
            "all_receive_transfers"
        ]
    },
    // {
    //     model: false,
    //     title: "daily_transactions",
    //     group_icon: "sync_alt",
    //     children: [
    //         {
    //             can: "all_credits",
    //             title: "cash_receipts",
    //             icon: "mdi-cash-check",
    //             path: "/daily-transactions/credits"
    //         },
    //         {
    //             can: "all_debits",
    //             title: "cash_payments",
    //             icon: "mdi-cash-refund",
    //             path: "/daily-transactions/debits"
    //         },
    //         {
    //             title: "exchanges",
    //             can: "all_exchanges",
    //             icon: "mdi-stack-exchange",
    //             path: "/daily-transactions/exchanges"
    //         },
    //         {
    //             can: "all_a2a_transfers",
    //             title: "a2a_transfers",
    //             icon: "mdi-database-sync",
    //             path: "/daily-transactions/a2a-transfers"
    //         },
    //         {
    //             title: "send_transfers",
    //             can: "all_send_transfers",
    //             icon: "mdi-database-arrow-right",
    //             path: "/daily-transactions/send-transfers"
    //         },
    //         {
    //             title: "receive_transfers",
    //             can: "all_receive_transfers",
    //             icon: "mdi-database-arrow-left",
    //             path: "/daily-transactions/receive-transfers"
    //         }
    //     ]
    // },
    {
        heading: "exteranl_accounts",
        cans: ["all_individuals", "all_corporates", "all_customers", "all_sarafs", "all_staffs", "all_branchs", "all_shareholders"],
    },
    {
        model: false,
        title: "registration",
        group_icon:"mdi-account-details",
        cans: ["all_individuals", "all_corporates", "all_customers", "all_sarafs", "all_staffs", "all_branchs", "all_shareholders"],
        children: [
            {
                title: "individuals",
                path: "/individuals",
                icon: "account_box",
                can: "all_individuals"
            },
            {
                icon: "business",
                path: "/corporates",
                title: "corporates",
                can: "all_corporates"
            },
            {
                icon: "people",
                path: "/customers",
                title: "externals",
                can: "all_customers"
            },
            {
                path: "/staffs",
                title: "staff_reg",
                can: "all_staffs",
                icon: "mdi-account-hard-hat",
            },
            {
                title: "shareholders",
                path: "/shareholders",
                can: "all_shareholders",
                icon: "mdi-account-tie"
            },
            {
                path: "/branchs",
                can: "all_branchs",
                title: "branches",
                icon: "mdi-file-tree-outline"
            },
            {
                path: "/sarafs",
                can: "all_sarafs",
                title: "sarafs",
                icon: "mdi-account-details"
            },
            {
                path: "/commissions",
                can: "all_commissions",
                title: "sarafs_commission",
                icon: "mdi-account-details"
            },
        ]
    },

    {
        heading: "system_accounts",
        cans: ["view_cash_accounts", "all_banks", "all_expenses", "all_incomes"]
    },

    {
        icon: "local_atm",
        can: "view_cash_accounts",
        title: "cash_accounts",
        path: "/branch-accounts"
    },
    {
        title: "banks",
        path: "/banks",
        can: "all_banks",
        icon: "account_balance"
    },
    {
        icon: "fastfood",
        path: "/expenses",
        title: "expenses",
        can: "all_expenses"
    },
    {
        path: "/incomes",
        title: "incomes",
        can: "all_incomes",
        icon: "mdi-wallet-plus"
    },
    {
        path: "/assets",
        can: "all_assets",
        title: "assets",
        icon: "mdi-cellphone-link"
    },
    {
        path: "/liabilities",
        can: "all_liabilities",
        title: "other_liabilities",
        icon: "mdi-cellphone-link"
    },
    {
        model: false,
        group_icon: "bar_chart",
        title: "reports",
        children: [
            {
                path: "/reports",
                icon: "mdi-chart-arc",
                can: "ledger_report",
                title: "general_ledger"
            },
            {
                can: "lctr_report",
                path: "/lctr-report",
                title: "lctr_report",
                icon: "mdi-chart-bell-curve-cumulative"
            },
            {
                can: "lctr_report",
                path: "/non-lctr-report",
                title: "non_lctr_report",
                icon: "mdi-chart-bell-curve-cumulative"
            },
            {
                can: "lctr_report",
                path: "/income-statement",
                title: "income_statement",
                icon: "mdi-file-chart-outline"
            },
            {
                can: "lctr_report",
                title: "balance_sheet",
                path: "/balance-sheet",
                icon: "mdi-scale-balance"
            },
            {
                icon: "sync_alt",
                can: "transactions_report",
                title: "transactions_report",
                path: "/transactions-report"
            },
            {
                icon: "mdi-bell",
                path: "/notifications",
                can: "transactions_report",
                title: "notification_report",
            },
            {
                icon: "account_box",
                can: "all_individuals",
                title: "individuals_report",
                path: "/individuals-kyc-report?kyc=true"
            },
            {
                icon: "business",
                can: "all_corporates",
                title: "corporates_report",
                path: "/corporates-kyc-report?kyc=true"
            }
        ]
    },
    {
        model: false,
        title: "settings",
        group_icon: "settings",
        children: [
            {
                path: "/roles",
                title: "roles",
                can: "all_roles",
                icon: "data_usage"
            },
            {
                path: "/users",
                title: "users",
                can: "all_users",
                icon: "account_circle"
            },
            {
                title: "currencies",
                path: "/currencies",
                can: "all_currencies",
                icon: "monetization_on"
            },
            {
                icon: "backup",
                path: "/backups",
                title: "backups",
                can: "all_backups"
            }
        ]
    }
];
